import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faMapMarkerAlt, faEdit, faStreetView, faRoute } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment';
import { MapContainer, TileLayer, Marker, Polyline, Tooltip } from 'react-leaflet';
//Assets
import { iconeNormal } from '../../../../assets/Icons/Icons';
//Components
import TabelaListaGeradores from './TabelaListaGeradores';
//Helpers
import { conectarPontos, MAPA_TILE_URL, MAPA_TILE_ATTRIBUTION } from '../../../../helpers/mapas';

export default function ContainerFichaRota({ ordemAvulsa, rotaColeta, idRotaOrdem, idRotaManutencao, editar }) {
    //Referencia do mapa
    const [map, setMap] = useState(null);
    //Localização em que o mapa será centralizado
    const [location, setLocation] = useState([-23.2198396, -45.8915658]);
    //Estado de controle da visualização de satelite no mapa
    const [viewSatelite, setViewSatelite] = useState(() => false);
    //Troca do estado da visualização do modo de sateleti
    const toggleViewSatelite = () => setViewSatelite(() => !viewSatelite);
    const [pointSelected, setPointSelected] = useState(null);
    //Vetor de linhas que são mostradas no mapa
    const [linhas, setLinhas] = useState([]);
    if (rotaColeta && rotaColeta.items) {
        rotaColeta.geradores = [...rotaColeta.items];
    }
    useEffect(() => {
        const _linhas = [];
        if (rotaColeta.geradores) {
            setLinhas(conectarPontos(rotaColeta.geradores));
        }
    }, [])
    const greenOptions = { color: 'green' }
    return (
        <div className='mb-3' style={{ color: "#666" }}>
            {ordemAvulsa || idRotaOrdem || idRotaManutencao
                ?
                <div className="d-flex align-items-center justify-content-between">
                    <p><span className="fw-bold">Data:</span> {moment().format("DD/MM/YYYY")}</p>
                    <p><span className="fw-bold">Status:</span> Não programada</p>
                </div>
                : <></>
            }
            <h5 className="bg-gradient bg-primary p-2 rounded-3 text-light d-flex align-items-center justify-content-between"><span><FontAwesomeIcon className='me-2' icon={faPencilAlt} /> Identificação da rota</span> {editar ? <button className='btnEditFicha' onClick={() => editar(1)}><FontAwesomeIcon icon={faEdit} /></button> : <></>}</h5>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Descrição: </span> {rotaColeta && rotaColeta.descricao}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Veiculo: </span> {rotaColeta && rotaColeta.placaVeiculo}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Destino: </span> {rotaColeta && rotaColeta.fantasiaDestino}</p>
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Status: </span> {rotaColeta && rotaColeta.status}</p>
                </Col>
            </Row>
            <h5 className="bg-gradient bg-primary p-2 rounded-3 text-light d-flex align-items-center justify-content-between"><span><FontAwesomeIcon className='me-3' icon={faMapMarkerAlt} /> Lista de geradores</span> {editar ? <button className='btnEditFicha' onClick={() => editar(2)}><FontAwesomeIcon icon={faEdit} /></button> : <></>}</h5>
            <TabelaListaGeradores items={rotaColeta && rotaColeta.geradores ? [...rotaColeta.geradores] : []} ficha={true} />
            <h5 className="bg-gradient bg-primary p-2 rounded-3 text-light d-flex align-items-center justify-content-between"><span><FontAwesomeIcon className='me-3' icon={faRoute} />Rota de coleta</span> {editar ? <button className='btnEditFicha' onClick={() => editar(2)}><FontAwesomeIcon icon={faEdit} /></button> : <></>}</h5>

            <Row style={{ height: "50vh", backgroundColor: "#eee" }} className="mt-3 rounded-3 overflow-hidden shadow">
                <Col md="12" lg="12" className=' m-0 p-0'>
                    <MapContainer
                        center={rotaColeta.geradores && rotaColeta.geradores.length > 0 ? [rotaColeta.geradores[0].latitude, rotaColeta.geradores[0].longitude] : location}
                        zoom={13}
                        ref={setMap}
                        whenCreated={map => setMap(map)}
                        style={{ height: "100%", width: "100%", backgroundColor: "#333" }}
                    >
                        <Button color='light border' className='buttonSatelite' onClick={toggleViewSatelite}><FontAwesomeIcon size='1x' icon={faStreetView} /></Button>
                        <TileLayer
                            url={MAPA_TILE_URL}
                            attribution={MAPA_TILE_ATTRIBUTION}
                        />
                        {
                            viewSatelite
                            &&
                            <TileLayer
                                url='https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
                                maxZoom={20}
                                subdomains={['mt1', 'mt2', 'mt3']}
                            />

                        }



                        {rotaColeta && rotaColeta.geradores && rotaColeta.geradores.map((value, index) => {
                            if (value.latitude && value.longitude && !isNaN(parseFloat(value.latitude.replace(",", "."))) && !isNaN(parseFloat(value.longitude.replace(",", ".")))) {
                                return (
                                    <Marker key={index} icon={iconeNormal} position={[parseFloat(value.latitude.replace(",", ".")), parseFloat(value.longitude.replace(",", "."))]}
                                        eventHandlers={{
                                            click: (e) => {
                                                setLocation(e.latlng);
                                                map.flyTo(e.latlng);
                                                setPointSelected(value);
                                            },
                                        }}
                                    >
                                        <Tooltip direction='center' className='leaflet-tooltip-green' offset={[0, 0]} opacity={1} permanent>
                                            <span>{value.sequencia}</span>
                                        </Tooltip>
                                    </Marker>
                                )
                            }
                        })}
                        {
                            linhas.map(value => {
                                return <Polyline pathOptions={greenOptions} positions={value} />
                            })
                        }
                    </MapContainer>
                </Col>
            </Row>
        </div>
    )
}